<template>
	<div class="p-grid">
		<div class="p-col-12">
			<div class="card">
				<!-- <Toolbar class="p-mb-0">
					<template v-slot:left>
						<label>年度：</label>
						<Dropdown placeholder="选择" @input="advancedSearch" v-model="filters.year" :options="years" :showClear="true"></Dropdown>
					</template>

					<template v-slot:right>
						<span class="p-input-icon-left">
							<i class="pi pi-search" />
							<InputText v-on:keyup.enter="basicSearch" v-model="searchKeyword" placeholder="检索" />
						</span>
					</template>
				</Toolbar> -->

				<DataTable :value="proposals" dataKey="_id" :rows="25" :rowHover="true" showGridlines :removableSort="true"
							:paginator="true" paginatorPosition="both" ref="dt" v-model:first="currentPageFirstIndex" 
							paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" :rowsPerPageOptions="[5,10,25,50]"
							currentPageReportTemplate="Showing {first} to {last} of {totalRecords} proposals" responsiveLayout="stack"
							:lazy="true" :totalRecords="totalRecords" :loading="loading" @page="onPage($event)" @sort="onSort($event)">
					<template #header>
						<div style="text-align: center">
							<h4 class="p-m-0">已审核</h4>
						</div>
					</template>

					<Column header="序号" headerStyle="width: 6em; text-align: left">
						<template #body="slotProps">
							<span style="color: RGB(33,150,243)">{{currentPageFirstIndex + slotProps.index + 1}}</span>
						</template>
					</Column>
					<Column header="束流申请编号">
						<template #body="slotProps">
							{{slotProps.data.number}}
						</template>
					</Column>
					<Column header="实验名称">
						<template #body="slotProps">
							<div style="cursor:pointer" @click="$router.push({ name: 'proposalinfo', params: { id: slotProps.data._id } })">{{slotProps.data.experimentName}}</div>
						</template>
					</Column>
					<Column header="实验负责人">
						<template #body="slotProps">
							{{slotProps.data.ownerName}}
						</template>
					</Column>
					<Column header="单位">
						<template #body="slotProps">
							{{slotProps.data.ownerOrganization}}
						</template>
					</Column>
					<Column header="实验开始时间">
						<template #body="slotProps">
							{{showDateTime(slotProps.data.expectedDate)}}
						</template>
					</Column>
					<Column header="申请束流时间（小时）">
						<template #body="slotProps">
							{{slotProps.data.requestBeamTime}}
						</template>
					</Column>
					<Column header="提案提交时间">
						<template #body="slotProps">
							<div v-if="slotProps.data.submittedAt">{{showDateTime(slotProps.data.submittedAt)}}</div>
						</template>
					</Column>
					<Column header="状态" bodyStyle="text-align: center">
						<template #body="slotProps">
							<div :style="{'background-color': showProposalStatusColor(slotProps.data), 'line-height': '2em'}">
								{{ showProposalStatus(slotProps.data) }}
							</div>
						</template>
					</Column>
					<Column>
						<template #header>
							审核人
						</template>
						<template #body="slotProps">
							<div>{{ showProposalApprover(slotProps.data) }}</div>
						</template>
					</Column>
					<Column header="操作">
						<template #body="slotProps">
							<Button icon="fa fa-info" class="p-button-rounded p-button-primary p-mr-2" @click="showProposalInfo(slotProps.data)" />
							<!-- <Button icon="pi pi-file-pdf" class="p-button-rounded p-button-help" @click="createPdf(slotProps.data)" /> -->
						</template>
					</Column>
				</DataTable>

				<Dialog v-model:visible="showProposalInfoDialog" :style="{width: '80%'}" header="提案信息" :modal="true" :maximizable="true">
					<ProposalData :proposal="proposal" />
					<template #footer>
						<Button label="关闭" icon="pi pi-times" class="p-button-primary" @click="showProposalInfoDialog = false"/>
					</template>
				</Dialog>

			</div>
		</div>
	</div>

</template>

<script>
import ProposalService from '../service/ProposalService';
import ProposalData from './ProposalData';
const dateFormat = require('dateformat');


export default {
	data() {
		return {
			lazyParams: {},
			totalRecords: 0,
			loading: false,

			proposals: null,
			showProposalInfoDialog: false,
			proposal: {},
			filters: {},
			// currentYear: new Date().getFullYear(),
			// years: [],

			currentPageFirstIndex: 0,
		}
	},
	proposalService: null,
	created() {
		this.proposalService = new ProposalService();
	},
	mounted() {
		// Permission guard
		if(!this.canApprove) {
			this.$router.push({path: '/access'});
			return;
		}

		this.resetLazyParams();
		this.loadLazyData();

		// this.years.push(this.currentYear - 2);
        // this.years.push(this.currentYear - 1);
        // this.years.push(this.currentYear);
		// this.years.push(this.currentYear + 1);
		// this.years.push(this.currentYear + 2);
	},
	methods: {
		loadLazyData() {
			this.loading = true;
			this.proposalService.findApproved(this.lazyParams)
			.then(data => {
				this.proposals = data.entries;
				this.totalRecords = data.count;
			}).catch(error => {
				if(error.response) {
					this.$toast.add({ severity: 'error', summary: '提案加载失败', detail: error.response.data.message });
				} else {
					this.$toast.add({ severity: 'error', summary: '提案加载失败', detail: error.message });
				}
			}).finally(() => {
				this.loading = false;
			});
		},
		onPage(event) {
            this.lazyParams.first = event.first;
			this.lazyParams.rows = event.rows;
			this.lazyParams.sortField = event.sortField;
			this.lazyParams.sortOrder = event.sortOrder;
            this.loadLazyData();
        },
        onSort(event) {
            this.lazyParams.first = event.first;
			this.lazyParams.rows = event.rows;
			this.lazyParams.sortField = event.sortField;
			this.lazyParams.sortOrder = event.sortOrder;
            this.loadLazyData();
        },
		onFilter() {
			this.resetLazyParams();
            this.lazyParams.filters = this.filters;
            this.loadLazyData();
        },
		resetLazyParams() {
			this.lazyParams = {
				first: 0,
				rows: this.$refs.dt.rows,
				sortField: null,
				sortOrder: null,
				filters: null
			};
		},

		showProposalInfo(proposal) {
			this.proposal = proposal;
			this.showProposalInfoDialog=true
		},
		basicSearch() {
			// let loader = this.$loading.show();
			if(this.searchKeyword != null && this.searchKeyword.length > 0) {
                this.filters.search = this.searchKeyword;
			} else {
				this.filters.search = null;
			}
			this.proposalService.findProposals(this.filters)
			.then(proposals => { 
				this.proposals = proposals; 
				// loader.hide();
				// this.$toast.add({severity: 'info', summary: '检索已完成', life: 3000});
			}).catch(error => {
				// loader.hide();
				if(error.response) {
					this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.response.data.message });
				} else {
					this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.message });
				}
			});
		},
		showProposalStatus(value) {
            return this.proposalService.showProposalStatus(value);
        },
        showProposalStatusColor(value) {
            return this.proposalService.showProposalStatusColor(value);
        },
		showProposalApprover(value) {
            return this.proposalService.showProposalApprover(value);
        },
		createPdf(data) {
			this.proposalService.createPdf(data);
		},
		showDate(value) {
            return dateFormat(value, "yyyy-mm-dd");
        },
        showTime(value) {
            return dateFormat(value, "HH:MM");
        },
        showDateTime(value) {
            return dateFormat(value, "yyyy-mm-dd HH:MM");
        },
	},
	components: {
        'ProposalData': ProposalData,
	},
	computed: {
		loggedIn() {
            return this.$store.state.authentication.status.loggedIn;
        },
        userInfo() {
            return this.$store.state.authentication.user;
		},
		canApprove() {
            return this.isPreapprover || this.isApprover;
        },
        isPreapprover() {
			return this.$store.state.authentication.permissions.preapprover === true;
        },
        isApprover() {
			return this.$store.state.authentication.permissions.approver === true;
		},
    }
}
</script>

<style scoped lang="scss">
	.table-header {
		display: flex;
		justify-content: space-between;
	}

	::v-deep(.p-toolbar) {
		flex-wrap: wrap;
		.p-button {
			margin-bottom: .25rem;
		}
	}
</style>
